import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import Cookies from 'js-cookie';

import posts from './modules/posts';
import vendors from './modules/vendors';
import search from './modules/search';
import user from './modules/user';
import shared from './modules/shared';
import prglistings from './modules/prglistings';
import listings from './modules/listings';
import contact from './modules/contact';

Vue.use(Vuex);

const vuexCookie = new VuexPersistence({
  key: 'prpg_user',
  restoreState: (key, storage) => Cookies.getJSON(key),
  saveState: (key, state, storage) =>
    Cookies.set(key, state, { expires: 30, secure: true }),
  modules: ['user'],
  filter: (mutation) =>
    mutation.type == 'loginSuccess' || mutation.type == 'logoutSuccess',
});

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  plugins: [vuexCookie.plugin],
  modules: {
    shared,
    posts,
    vendors,
    user,
    prglistings,
    listings,
    contact,
    search,
  },
});
